if (!customElements.get('featured-collection-slider')) {
    customElements.define('featured-collection-slider', class FeaturedCollectionSlider extends HTMLElement {
        constructor(){
            super();
            this.carousel = this.querySelector('[data-carousel]')
            this.navButtons = this.querySelectorAll('.nav-button');
            this.productCards = this.querySelectorAll('.featured-collection-product');
            this.navButtons = this.querySelectorAll('.nav-button');
            this.index = 0;
            this.maxIndex = this.productCards.length - 1;
            this.mouseDown = false;
            this.isMoving = false;
            this.initialMargin = 0;
            this.scrollTicking = false;
            this.startX, this.tmpScrollLeft;
            this.carousel.addEventListener('mousedown', this.startDragging.bind(this), false);
            this.carousel.addEventListener('mouseup', this.stopDragging.bind(this), false);
            this.carousel.addEventListener('mouseleave', this.stopDragging.bind(this), false);
            this.carousel.addEventListener('click', this.handleClick.bind(this), false);
            this.carousel.addEventListener('mousemove', this.handleMouseMove.bind(this))
            this.carousel.addEventListener('touchmove', this.handleTouchMove.bind(this))
            this.navButtons.forEach(navButton => {
                navButton.addEventListener('click', e => {
                    e.preventDefault();
                    let moveBy = parseInt(navButton.dataset.move);
                    this.moveCarousel(moveBy);
                })
            })
            window.addEventListener('resize', this.setMaxIndex.bind(this), false);
            window.addEventListener('resize', this.equaliseProductTitles.bind(this), false);

            this.allCardHeadingsContainers = this.querySelectorAll('.card-header-container');
            this.allCardHeadings = this.querySelectorAll('.card-header-container .card__heading');

        }
        setMaxIndex(){
            this.productCards = this.querySelectorAll('.featured-collection-product');
            this.cardWidth = this.productCards[0].getBoundingClientRect().width + 16;
            let perScreen = Math.floor(this.carousel.getBoundingClientRect().width / this.cardWidth);
            this.maxIndex = (this.productCards.length - perScreen);
            // console.log(this.maxIndex)
        }
        moveCarousel(moveBy){
            this.index =  Math.min(Math.max(this.index + moveBy, 0), this.maxIndex);
            this.carousel.scrollLeft = this.index * this.cardWidth;
            this.checkDisabledButtons();
        }
        handleClick(e){
            //console.log(this.isMoving)
            if(this.isMoving){
                e.preventDefault();
            }
        }
        handleMouseMove(e){
            e.preventDefault();
            if(!this.mouseDown) { return }

            this.isMoving = true;

            const x = e.pageX - this.offsetLeft;
            const scroll = x - this.startX;
            this.carousel.scrollLeft = this.tmpScrollLeft - scroll;
            this.index = Math.floor(this.carousel.scrollLeft / this.cardWidth);
            this.checkDisabledButtons(1);
        }
        handleTouchMove(e){
            this.isMoving = true;

            const x = e.pageX - this.offsetLeft;
            const scroll = x - this.startX;
            // this.carousel.scrollLeft = this.tmpScrollLeft - scroll;
            this.index = Math.floor(this.carousel.scrollLeft / this.cardWidth);
            this.checkDisabledButtons(1);
        }
        startDragging(e){
            this.mouseDown = true;
            this.carousel.classList.add('is-dragging');
            this.startX = e.pageX - this.offsetLeft;
            this.tmpScrollLeft = this.carousel.scrollLeft;
            if (this.isMoving){
                e.preventDefault();
            }
            
        }
        checkDisabledButtons(offset = 0){
            this.navButtons.forEach(button => button.removeAttribute('disabled'))
            if(this.index < 1){
                this.navButtons[0].setAttribute('disabled', true)
            }
            if(this.index >= this.maxIndex - offset ){
                this.navButtons[1].setAttribute('disabled', true)
            }
            
        }
        stopDragging(e) {
            e.preventDefault();
            this.mouseDown = false;
            this.carousel.classList.remove('is-dragging');
            setTimeout(() => {this.isMoving = false}, 100)
        }
        equaliseProductTitles(){
            let maxHeight = 0;
            this.allCardHeadings.forEach(heading => {
                let headingHeight = heading.getBoundingClientRect().height;
                if(headingHeight > maxHeight){
                    maxHeight = headingHeight
                }
            })
            this.allCardHeadingsContainers.forEach(heading => {
                
                heading.style.minHeight = 'unset';
                heading.style.height = `${Math.round(maxHeight)}px`;
            })
            
        }
        connectedCallback() {
            this.setMaxIndex();
            this.equaliseProductTitles();
        }
    })
}
